// Moved from /proxy/proxy.interface.js
import { coreEngine } from "../packages/engine.js";
import { time } from "../packages/time.js";

export class NodeProxy {
  constructor(uid, senderNode) {
    if (!senderNode) {
      throw new Error(`The sender node for proxy with uid ${uid} is not specified!`);
    }

    this.uid = uid
    this.sender = senderNode.uid;
    this._senderNode = senderNode;
  }

  tell(message) {
    const messageCopy = { ...message };
    messageCopy.sender = this.sender;
    messageCopy.time ??= time.current;

    coreEngine.update({
      uid: this.uid,
      key: "receiveMessage",
      value: messageCopy,
    });
  }

  notifyDisconnected() {
    this._senderNode.tell({
      type: "proxy_connection_lost",
      proxyUid: this.uid,
    });
  }
}